// Dev BE now has its own host, mirroring how prod calls api.starcompliance.io
// absolutely. This is a cross-origin call — the dev BE allow-lists
// https://app-dev.safemycrypto.com, which is where this build is served.
// apiUrl is baked at build time, so changing it needs a rebuild + redeploy.
export const environment = {
  production: false,
  apiUrl: 'https://api-dev.starcompliance.io',
};
